export const sajuQueryKeys = {
  /** AI 분석 상태/결과 조회 */
  aiReadingStatus: (sajuType: string, hashKey: string) =>
    ['saju', sajuType, 'ai-reading-status', hashKey] as const,

  /** 분석 내역 목록 */
  readingHistory: (sajuType: string) => ['saju', sajuType, 'reading-history'] as const,

  /** 후속 질문 대화 이력 */
  followUpHistory: (sajuType: string, hashKey: string) =>
    ['saju', sajuType, 'follow-up-history', hashKey] as const,
}
